module.exports = __webpack_public_path__ + "img/bg.9d43120c.png";